import React from 'react'
import './CategoryBlock.css';
import GridViewIcon from '@mui/icons-material/GridView';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Card from '../../Card/Card';
import { Stack, Skeleton } from '@mui/material';
import PaginationBlock from '../PaginationBlock/PaginationBlock';

export default function CategoryBlock({ productList, type, setCurrentStatus, viewStatus, setViewStatus, notFound, setPage, documentsData }) {

    return (
        <div className='col-12 col-md-9 col-xl-10'>
            {
                productList?.length > 0 ?
                    <React.Fragment>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="filters-block">
                                    <span className="btn simple-product-explanation p-0 m-0">
                                        {type ? type : 'Search: '}(Showing 1 - {productList?.length} of {productList?.length} items)
                                    </span>
                                </div>

                            </div>
                            <div className="col-md-3" style={{ textAlign: 'right' }}>
                                <div className="filters-block">
                                    <select className="form-select" onChange={(e) => setCurrentStatus(e.target.value)} aria-label="Default select example">
                                        <option defaultValue>Sort By</option>
                                        <option value="price-low-to-high">Price Low to High</option>
                                        <option value="price-high-to-low">Price High to Low</option>
                                    </select>
                                </div>

                            </div>
                            <div className="d-none d-md-block col-md-3 p-0">
                                <div className="filters-block">
                                    <button className="btn" onClick={() => setViewStatus('grid')} style={{ marginRight: '5px' }}>
                                        <GridViewIcon />
                                    </button>
                                    <button className="btn" onClick={() => setViewStatus('list')}>
                                        <FormatListBulletedIcon />
                                    </button>
                                </div>
                            </div>

                        </div>
                        <hr className='d-none d-md-block' />

                        <div className="row">
                            {
                                notFound ?
                                    <p className='text-dark'
                                        style={{ fontWeight: 'bolder' }}
                                    >
                                        Coming Soon...
                                    </p> :
                                    productList?.map((item, index) => (
                                        <div className={`${viewStatus === 'list' ? 'col-sm-6 col-md-12 col-lg-8' : 'col-sm-6 col-md-6 col-lg-4 col-xl-3'}  mt-2`} key={index}>
                                            <Card item={item} viewStatus={viewStatus} type={item.category} />
                                        </div>
                                    ))
                            }
                        </div>
                        {
                            !notFound && <PaginationBlock productList={productList} setPage={setPage} documentsData={documentsData} />
                        }
                        
                    </React.Fragment>
                    :
                    <div className="row">
                        {
                            [1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => (

                                <div className="col-sm-3 mt-3 mb-3 col-12" key={index}>
                                    <Stack spacing={1}>
                                        <Skeleton variant="rectangular" width={'100%'} height={118} />
                                        <Skeleton variant="text" />
                                        <Skeleton variant="text" />
                                    </Stack>
                                </div>

                            ))
                        }

                    </div>
            }
        </div>
    )
}
